<template>
  <div class="f-invalid-session">
    <f-modal-base class="f-invalid-session" :title2="component.label">
      <template #content>
        <p>{{ component.help }}</p>
      </template>
      <template #actions>
        <f-button
          v-for="action in component.actions"
          :key="action.label"
          type="primary"
          @click="action.callback()"
          >{{ action.label }}</f-button
        >
      </template>
    </f-modal-base>
  </div>
</template>
<script>
export default {
  data() {
    return {
      actionKey: 0,
    };
  },
  props: ["component", "handler"],
  methods: {
    reload() {
      window.location.reload();
    },
  },
  mounted() {
    console.warn("invalid session");
  },
};
</script>
<style lang="scss">
.f-invalid-session {
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>